/* Pantheratec Fenster-Konfigurator v1.1 – keine Drittanbieter, kein Tracking. */
(function () {
  'use strict';
  var initialized = new WeakSet();
  var LOCATION_LABELS = {
    seitenwand: 'Seitenwand', heck: 'Hecktür / Heckwand',
    aufbau: 'Aufbauwand', dach: 'Dachfläche', sonstiges: 'anderer Bereich'
  };

  function node(tag, className, content) {
    var element = document.createElement(tag);
    if (className) element.className = className;
    if (content !== undefined && content !== null) element.textContent = String(content);
    return element;
  }
  function paragraph(text, className) { return node('p', className || '', text); }
  function cleanNumber(value) { return Number(String(value || '').replace(',', '.')); }
  function isProduct(item) {
    return !!(item && item.id && item.url && Number(item.width) > 0 && Number(item.height) > 0 &&
      Number(item.minWall) > 0 && Number(item.maxWall) >= Number(item.minWall));
  }
  function available(item) { return !!(item && item.available && isProduct(item)); }
  function sizeKey(item) { return String(item.width) + 'x' + String(item.height); }
  function productUrl(item) {
    return item.url + (item.url.indexOf('?') === -1 ? '?' : '&') + 'variant=' + encodeURIComponent(item.id);
  }
  function matchCore(item, request) {
    if (!available(item)) return false;
    if (request.opening !== 'any' && item.opening !== request.opening) return false;
    if (request.wall < Number(item.minWall) || request.wall > Number(item.maxWall)) return false;
    if (request.mode === 'existing') {
      // Exact cutout only: no invented tolerance and no automatic 90° rotation.
      if (Number(item.width) !== request.width || Number(item.height) !== request.height) return false;
    } else {
      if (Number(item.width) > request.width || Number(item.height) > request.height) return false;
    }
    return true;
  }
  function pickOwn(products, request) {
    var own = products.filter(function (p) { return p.origin === 'own' && matchCore(p, request); });
    var groups = {};
    own.forEach(function (p) {
      var key = sizeKey(p);
      if (!groups[key]) groups[key] = {};
      groups[key][p.kind] = p;
    });
    var selected = [];
    Object.keys(groups).forEach(function (key) {
      var group = groups[key];
      if (request.rollo === 'yes') {
        if (group.set) {
          selected.push({ primary: group.set, items: [group.set], kind: 'set', source: 'own' });
        } else if (group.window && group.rollo) {
          selected.push({ primary: group.window, items: [group.window, group.rollo], kind: 'combo', source: 'own' });
        }
      } else if (request.rollo === 'no') {
        if (group.window) selected.push({ primary: group.window, items: [group.window], kind: 'window', source: 'own' });
      } else {
        // Avoid showing two near-duplicate results for one size.
        if (group.window) selected.push({ primary: group.window, items: [group.window], kind: 'window', source: 'own' });
        else if (group.set) selected.push({ primary: group.set, items: [group.set], kind: 'set', source: 'own' });
      }
    });
    return selected;
  }
  function pickOther(products, request) {
    return products.filter(function (p) {
      if (p.origin !== 'other' || !matchCore(p, request)) return false;
      if (request.rollo === 'yes' && !p.withRollo) return false;
      if (request.rollo === 'no' && p.withRollo) return false;
      return true;
    }).map(function (p) { return { primary: p, items: [p], kind: p.withRollo ? 'set' : 'window', source: 'other' }; });
  }
  function sortResults(list, request) {
    return list.sort(function (a, b) {
      var areaA = Number(a.primary.width) * Number(a.primary.height);
      var areaB = Number(b.primary.width) * Number(b.primary.height);
      if (areaA !== areaB) return request.sizePreference === 'compact' ? areaA - areaB : areaB - areaA;
      return a.items.reduce(function (s, p) { return s + Number(p.price); }, 0) -
        b.items.reduce(function (s, p) { return s + Number(p.price); }, 0);
    });
  }
  // Roof products discovered through Shopify Predictive Search are catalogue leads,
  // not verified fitment: a 400 x 400 title can refer to outside dimensions.
  function roofTitle(item) {
    var title = String(item && item.title || '').toLocaleLowerCase('de-DE');
    if (!/(dachfenster|dachhaube|dachluke|dachlicht|oberlicht|rooflight|roof window)/.test(title)) return false;
    if (/(ersatzteil|ersatzglas|ersatzdeckel|abdeckhaube|ersatzrahmen|dichtungssatz|adapterrahmen|montagerahmen|dachhaubenrollo|dachfensterrollo)/.test(title)) return false;
    return true;
  }
  function titleDimensions(title) {
    // Only a NENNmaß hint from product title. Never a certified cutout dimension.
    var match = String(title || '').match(/(?:^|[^\d])(\d{2,4})\s*[x×]\s*(\d{2,4})\s*(mm|cm)?/i);
    if (!match) return null;
    var w = Number(match[1]), h = Number(match[2]);
    var centimeters = (String(match[3] || '').toLowerCase() === 'cm') || (!match[3] && w < 100 && h < 100);
    if (centimeters) { w *= 10; h *= 10; }
    if (w < 100 || h < 100 || w > 2500 || h > 1500) return null;
    return { width: w, height: h };
  }
  function roofHintEligible(item, request) {
    if (!item || item.available !== true || !roofTitle(item)) return false;
    var dims = titleDimensions(item.title);
    if (!dims) return true; // no dimensional claim; only offers user a link for inspection
    if (request.mode === 'existing') {
      return dims.width === request.width && dims.height === request.height;
    }
    return dims.width <= request.width && dims.height <= request.height;
  }
  function searchRoofProducts(rootUrl) {
    var route = String(rootUrl || '/');
    if (route.charAt(route.length - 1) !== '/') route += '/';
    var terms = ['dachfenster', 'dachhaube', 'dachluke', 'oberlicht'];
    return Promise.all(terms.map(function (term) {
      var params = new URLSearchParams();
      params.set('q', term);
      params.set('resources[type]', 'product');
      params.set('resources[limit]', '10');
      params.set('resources[options][unavailable_products]', 'hide');
      return fetch(route + 'search/suggest.json?' + params.toString(), {
        credentials: 'same-origin', headers: { Accept: 'application/json' }
      }).then(function (response) {
        if (!response.ok) throw new Error('Shop-Suche HTTP ' + response.status);
        return response.json();
      }).then(function (body) {
        return { ok: true, products: (body.resources && body.resources.results && body.resources.results.products) || [] };
      }).catch(function () { return { ok: false, products: [] }; });
    })).then(function (answers) {
      var dedup = new Map();
      answers.forEach(function (answer) {
        answer.products.forEach(function (item) {
          if (!item || !item.available || !item.title || !item.url) return;
          var key = String(item.handle || item.id || item.url);
          if (!dedup.has(key)) dedup.set(key, item);
        });
      });
      return { products: Array.from(dedup.values()), success: answers.some(function (a) { return a.ok; }) };
    });
  }
  function init(root) {
    if (initialized.has(root)) return;
    var products, config;
    try {
      products = JSON.parse(root.querySelector('[data-ptwc-products]').textContent);
      config = JSON.parse(root.querySelector('[data-ptwc-config]').textContent);
    } catch (error) {
      console.error('[Pantheratec Fenster-Konfigurator] Ungültige Produktdaten:', error);
      return;
    }
    initialized.add(root);
    products = (Array.isArray(products) ? products : []).filter(isProduct);
    var form = root.querySelector('[data-ptwc-form]');
    if (!form) return;
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-ptwc-step]'));
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-ptwc-step-tab]'));
    var progress = root.querySelector('[data-ptwc-progress]');
    var counter = root.querySelector('[data-ptwc-counter]');
    var next = root.querySelector('[data-ptwc-next]');
    var back = root.querySelector('[data-ptwc-back]');
    var navigation = root.querySelector('[data-ptwc-navigation]');
    var error = root.querySelector('[data-ptwc-error]');
    var summary = root.querySelector('[data-ptwc-summary]');
    var results = root.querySelector('[data-ptwc-results]');
    var wizard = root.querySelector('[data-ptwc-wizard]');
    var current = 0;
    var renderToken = 0;
    var basket = new Map();
    var priceFormat;
    try {
      priceFormat = new Intl.NumberFormat(document.documentElement.lang || 'de-DE', {
        style: 'currency', currency: config.currency || 'EUR'
      });
    } catch (e) {
      priceFormat = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' });
    }
    function price(cents) { return priceFormat.format((Number(cents) || 0) / 100); }
    function get(name) { return form.elements.namedItem(name); }
    function value(name) {
      var element = get(name);
      if (!element) return '';
      if (typeof element.value === 'string') return element.value;
      var found = form.querySelector('input[name="' + name + '"]:checked');
      return found ? found.value : '';
    }
    function request() {
      return {
        vehicle: value('vehicle'), location: value('location'), structure: value('structure'),
        mode: value('mode'), width: cleanNumber(value('width')), height: cleanNumber(value('height')),
        wall: cleanNumber(value('wall')), opening: value('opening'), rollo: value('rollo'),
        sizePreference: value('sizePreference')
      };
    }
    function showError(message, focus) {
      error.textContent = message;
      error.hidden = false;
      if (focus && typeof focus.focus === 'function') { focus.classList.add('is-error'); focus.focus(); }
    }
    function clearError() {
      error.textContent = '';
      error.hidden = true;
      root.querySelectorAll('.ptwc__field .is-error').forEach(function (item) { item.classList.remove('is-error'); });
    }
    function validate(step) {
      clearError();
      var q = request();
      if (step === 0) {
        if (!q.vehicle) { showError('Bitte wähle zuerst deine Fahrzeugart aus.', get('vehicle')); return false; }
        if (!q.location) { showError('Bitte gib den geplanten Einbauort an.', get('location')); return false; }
        if (!q.structure) { showError('Bitte gib an, ob die Einbaufläche konstruktiv geprüft ist.', form.querySelector('[name="structure"]')); return false; }
      }
      if (step === 1) {
        var w = get('width'), h = get('height');
        if (!Number.isFinite(q.width) || q.width < 100 || q.width > 2500 || !Number.isInteger(q.width)) {
          showError('Bitte eine gültige Ausschnittbreite zwischen 100 und 2.500 mm angeben.', w); return false;
        }
        if (!Number.isFinite(q.height) || q.height < 100 || q.height > 1500 || !Number.isInteger(q.height)) {
          showError('Bitte eine gültige Ausschnitthöhe zwischen 100 und 1.500 mm angeben.', h); return false;
        }
      }
      if (step === 2) {
        if (!Number.isFinite(q.wall) || q.wall < 1 || q.wall > 150) {
          showError('Bitte die fertige Wandstärke in mm zwischen 1 und 150 angeben.', get('wall')); return false;
        }
        if (!q.rollo) { showError('Bitte den Wunsch nach Insektenschutz und Verdunkelung auswählen.', form.querySelector('[name="rollo"]')); return false; }
      }
      return true;
    }
    function setStep(step) {
      current = Math.min(Math.max(step, 0), 3);
      panels.forEach(function (panel, index) { panel.hidden = index !== current; });
      tabs.forEach(function (tab, index) {
        tab.classList.toggle('is-current', index === current);
        tab.classList.toggle('is-done', index < current);
        if (index === current) tab.setAttribute('aria-current', 'step'); else tab.removeAttribute('aria-current');
      });
      progress.setAttribute('aria-valuenow', String(current + 1));
      progress.querySelector('span').style.width = ((current + 1) * 25) + '%';
      counter.textContent = 'Schritt ' + (current + 1) + ' von 4';
      navigation.hidden = current === 3;
      back.hidden = current === 0;
      next.textContent = current === 2 ? 'Passende Fenster anzeigen →' : 'Weiter →';
      clearError();
      if (current === 3) renderResults();
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        wizard.scrollIntoView({ block: 'start' });
      } else {
        wizard.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
    function updateLocation() {
      var roof = value('location') === 'dach';
      var field = root.querySelector('[data-ptwc-opening-field]');
      var intro = root.querySelector('[data-ptwc-wishes-intro]');
      if (field) field.hidden = roof;
      var wallLabel = root.querySelector('[data-ptwc-wall-label]');
      var wallHint = root.querySelector('[data-ptwc-wall-hint]');
      if (wallLabel) wallLabel.textContent = roof ? 'Fertige Dachstärke am Einbauort' : 'Fertige Wandstärke am Einbauort';
      if (wallHint) wallHint.textContent = roof ? 'Kompletten Dachaufbau inklusive Innenverkleidung und ggf. Verstärkung messen.' : 'Mit Innenverkleidung, Distanzrahmen und Wandaufbau messen.';
      if (intro) intro.textContent = roof ?
        'Für Dachflächen suchen wir nach Dachfenstern oder Dachhauben. Entscheidend sind Ausschnittmaß, fertige Dachstärke und die geprüften Herstellerangaben.' :
        'Mit diesen Angaben filtern wir nach Ausschnittmaß, Wandstärke, Fenstertyp und gewünschtem Innenrollo.';
    }
    function updateMode() {
      var existing = value('mode') === 'existing';
      root.querySelector('[data-ptwc-width-label]').textContent = existing ? 'Breite des vorhandenen Ausschnitts' : 'Maximale Ausschnittbreite';
      root.querySelector('[data-ptwc-height-label]').textContent = existing ? 'Höhe des vorhandenen Ausschnitts' : 'Maximale Ausschnitthöhe';
      var note = root.querySelector('[data-ptwc-size-note] p');
      note.textContent = existing ?
        'Bei einem bestehenden Ausschnitt vergleichen wir nur exakt gleiche nominale Ausschnittmaße. Zulässige Toleranzen und der tatsächliche Rahmenüberstand müssen anhand der Herstellerunterlagen geprüft werden.' :
        'Bei einem neuen Ausschnitt prüfen wir, welche nominalen Ausschnittsgrößen innerhalb deiner Eingabe liegen. Für Außenrahmen, Dichtungen, Rollo und Öffnungsbereich ist zusätzlich Platz erforderlich.';
    }
    function addNotice(container, mode, text) {
      var notice = node('div', 'ptwc__notice ptwc__notice--' + mode);
      notice.appendChild(node('span', '', mode === 'danger' ? '!' : 'ⓘ'));
      notice.appendChild(paragraph(text));
      container.appendChild(notice);
    }
    function roofMatch(item, q) {
      if (item.opening !== 'dach' || !available(item)) return false;
      if (q.wall < Number(item.minWall) || q.wall > Number(item.maxWall)) return false;
      if (q.mode === 'existing') {
        if (q.width !== Number(item.width) || q.height !== Number(item.height)) return false;
      } else if (Number(item.width) > q.width || Number(item.height) > q.height) return false;
      if (q.rollo === 'yes' && !item.withRollo) return false;
      if (q.rollo === 'no' && item.withRollo) return false;
      return true;
    }
    function roofSearchLink(label) {
      var link = node('a', '', label || 'Alle Dachfenster im Shop suchen →');
      link.href = config.roofUrl || '/search?q=dachfenster&type=product';
      return link;
    }
    function createUnverifiedRoofCard(item) {
      var card = node('article', 'ptwc__result-card ptwc__result-card--unverified');
      var media = node('a', 'ptwc__result-card-media');
      media.href = item.url;
      media.setAttribute('aria-label', 'Dachprodukt ansehen: ' + item.title);
      var imageUrl = (item.featured_image && item.featured_image.url) || item.image;
      if (imageUrl) {
        var img = document.createElement('img');
        img.src = imageUrl; img.alt = item.title; img.loading = 'lazy';
        img.width = 320; img.height = 260;
        media.appendChild(img);
      } else media.appendChild(node('span', 'ptwc__result-card-placeholder', 'Dachprodukt ansehen'));
      var body = node('div', 'ptwc__result-card-body');
      var badges = node('div', 'ptwc__result-card-badges');
      badges.appendChild(node('span', 'ptwc__result-badge ptwc__result-badge--unverified', 'Einbaumaße noch prüfen'));
      badges.appendChild(node('span', 'ptwc__result-badge ptwc__result-badge--green', 'Im Shop verfügbar'));
      body.appendChild(badges);
      var title = node('h4');
      var link = node('a', '', item.title); link.href = item.url;
      title.appendChild(link); body.appendChild(title);
      var dims = titleDimensions(item.title);
      var details = node('div', 'ptwc__result-details');
      if (dims) details.appendChild(node('span', '', dims.width + ' × ' + dims.height + ' mm Nennmaß im Titel (nicht verifiziert)'));
      else details.appendChild(node('span', '', 'Ausschnittmaß nicht hinterlegt'));
      if (item.vendor) details.appendChild(node('span', '', item.vendor));
      body.appendChild(details);
      body.appendChild(paragraph('Dachstärke, Einbaurahmen, Ausschnittmaß und Rollo-Ausstattung vor der Bestellung prüfen.', 'ptwc__roof-info'));
      var row = node('div', 'ptwc__result-price-row');
      var pricing = node('div', 'ptwc__result-price');
      var numericPrice = Number(item.price_min !== undefined ? item.price_min : item.price);
      if (Number.isFinite(numericPrice) && numericPrice >= 0) {
        pricing.appendChild(node('strong', '', (item.price_min !== item.price_max && item.price_max !== undefined ? 'ab ' : '') + priceFormat.format(numericPrice)));
        pricing.appendChild(node('small', '', 'Shoppreis, inkl. MwSt.'));
      }
      row.appendChild(pricing);
      var actions = node('div', 'ptwc__result-card-actions');
      var detailsLink = node('a', 'ptwc__button ptwc__button--outline', 'Maße & Produkt prüfen →');
      detailsLink.href = item.url;
      actions.appendChild(detailsLink); row.appendChild(actions);
      body.appendChild(row); card.appendChild(media); card.appendChild(body);
      return card;
    }
    function showRoofSearch(q, verified, token) {
      var wrapper = node('section', 'ptwc__roof-discovery');
      var heading = node('h4', 'ptwc__results-title', verified.length ? 'Weitere Dachprodukte im Shop' : 'Dachfenster und Dachhauben im Shop suchen');
      wrapper.appendChild(heading);
      wrapper.appendChild(paragraph('Wir prüfen automatisch verfügbare Produkte in der Shopify-Suche. Treffer ohne geprüfte Ausschnittmaße zeigen wir nur als Produkte zum Nachmessen – nicht als garantiert passend.', 'ptwc__roof-explain'));
      var body = node('div', 'ptwc__roof-loading', 'Aktuelle Dachprodukte werden gesucht …');
      body.setAttribute('role', 'status');
      wrapper.appendChild(body);
      var foot = node('div', 'ptwc__roof-foot');
      foot.appendChild(roofSearchLink());
      wrapper.appendChild(foot);
      results.appendChild(wrapper);
      searchRoofProducts(config.root).then(function (response) {
        if (token !== renderToken || current !== 3) return;
        body.className = '';
        body.replaceChildren();
        if (!response.success) {
          body.appendChild(paragraph('Die automatische Shopify-Suche war gerade nicht erreichbar. Über den Link findest du Dachprodukte im Shop.', 'ptwc__roof-explain'));
          return;
        }
        var verifiedHandles = new Set(verified.map(function (entry) {
          var url = String(entry.primary.url || '');
          var match = url.match(/\/products\/([^?\/]+)/);
          return match ? decodeURIComponent(match[1]) : '';
        }));
        var suggestions = response.products.filter(function (item) {
          return roofHintEligible(item, q) && !verifiedHandles.has(String(item.handle || ''));
        });
        suggestions.sort(function (a, b) {
          var da = titleDimensions(a.title), db = titleDimensions(b.title);
          var ak = da ? 1 : 0, bk = db ? 1 : 0;
          if (ak !== bk) return bk - ak;
          if (da && db) return (db.width * db.height) - (da.width * da.height);
          return 0;
        });
        suggestions = suggestions.slice(0, 8);
        if (!suggestions.length) {
          body.appendChild(paragraph('Aktuell hat die begrenzte Shopify-Suche keine weiteren verfügbaren Dachfenster mit diesen Nennmaßen gefunden. Das bedeutet nicht, dass im gesamten Sortiment kein geeignetes Produkt existiert.', 'ptwc__roof-explain'));
          return;
        }
        var list = node('div', 'ptwc__result-list');
        suggestions.forEach(function (item) { list.appendChild(createUnverifiedRoofCard(item)); });
        body.appendChild(list);
        body.appendChild(paragraph('Achtung: Die Titelgröße ist keine bestätigte Schnittgröße. Auch bei gleichen Zahlen kann das Produkt ungeeignet sein. Für bestehende Öffnungen ist die Herstellerzeichnung maßgeblich.', 'ptwc__roof-explain'));
      }).catch(function () {
        if (token !== renderToken || current !== 3) return;
        body.className = '';
        body.replaceChildren(paragraph('Die Shop-Suche konnte nicht abgeschlossen werden. Bitte öffne die Dachfenster-Suche.', 'ptwc__roof-explain'));
      });
    }
    function listGroup(title, list, featured) {
      var group = document.createDocumentFragment();
      var heading = node('h4', 'ptwc__results-title');
      heading.appendChild(document.createTextNode(title + ' '));
      heading.appendChild(node('small', '', '(' + list.length + ')'));
      group.appendChild(heading);
      var cards = node('div', 'ptwc__result-list');
      list.forEach(function (item, idx) { cards.appendChild(createCard(item, !!featured && idx === 0)); });
      group.appendChild(cards);
      return group;
    }
    function createCard(item, featured) {
      var main = item.primary;
      var total = item.items.reduce(function (s, p) { return s + Number(p.price || 0); }, 0);
      var card = node('article', 'ptwc__result-card' + (featured ? ' ptwc__result-card--featured' : ''));
      var media = node('a', 'ptwc__result-card-media');
      media.href = productUrl(main);
      media.setAttribute('aria-label', 'Produkt ansehen: ' + main.title);
      if (main.image) {
        var photo = document.createElement('img');
        photo.src = main.image;
        photo.alt = main.title;
        photo.loading = 'lazy';
        photo.width = 320;
        photo.height = 260;
        media.appendChild(photo);
      } else {
        media.appendChild(node('span', 'ptwc__result-card-placeholder', 'Produkt ansehen'));
      }
      var body = node('div', 'ptwc__result-card-body');
      var badges = node('div', 'ptwc__result-card-badges');
      if (item.source === 'own') badges.appendChild(node('span', 'ptwc__result-badge', 'Pantheratec Eigenmarke'));
      if (featured) badges.appendChild(node('span', 'ptwc__result-badge ptwc__result-badge--green', 'Unsere Empfehlung'));
      if (item.kind === 'set') badges.appendChild(node('span', 'ptwc__result-badge ptwc__result-badge--warm', 'Fenster + Kombi-Rollo'));
      if (item.kind === 'combo') badges.appendChild(node('span', 'ptwc__result-badge ptwc__result-badge--warm', 'Zwei Einzelartikel'));
      if (main.opening === 'dach') badges.appendChild(node('span', 'ptwc__result-badge ptwc__result-badge--green', 'Ausschnitt & Dachstärke geprüft'));
      body.appendChild(badges);
      var title = node('h4');
      var link = node('a', '', item.kind === 'combo' ? 'Pantheratec Fenster + passendes Kombi-Rollo ' + main.width + ' × ' + main.height + ' mm' : main.title);
      link.href = productUrl(main);
      title.appendChild(link);
      body.appendChild(title);
      var details = node('div', 'ptwc__result-details');
      details.appendChild(node('span', '', main.width + ' × ' + main.height + ' mm Ausschnitt'));
      details.appendChild(node('span', '', main.minWall + '–' + main.maxWall + (main.opening === 'dach' ? ' mm Dachstärke' : ' mm Wandstärke')));
      details.appendChild(node('span', '', main.opening === 'dach' ? 'Dachfenster / Dachhaube' : main.opening === 'ausstell' ? 'Ausstellfenster' : main.opening === 'schiebe' ? 'Schiebefenster' : 'Festfenster'));
      body.appendChild(details);
      if (item.kind === 'combo') {
        var second = node('span', 'ptwc__result-details');
        var rLink = node('a', '', 'Enthaltenes Innenrollo ansehen →');
        rLink.href = productUrl(item.items[1]);
        second.appendChild(rLink);
        body.appendChild(second);
      }
      body.appendChild(node('p', 'ptwc__result-card-status', '● Verfügbar laut Shopify'));
      var row = node('div', 'ptwc__result-price-row');
      var pbox = node('div', 'ptwc__result-price');
      pbox.appendChild(node('strong', '', price(total)));
      pbox.appendChild(node('small', '', item.kind === 'combo' ? 'Gesamtpreis für beide Artikel' : 'inkl. MwSt., zzgl. ggf. Versand'));
      row.appendChild(pbox);
      var actions = node('div', 'ptwc__result-card-actions');
      var detailsLink = node('a', 'ptwc__button ptwc__button--outline', 'Details');
      detailsLink.href = productUrl(main);
      actions.appendChild(detailsLink);
      var add = node('button', 'ptwc__button ptwc__button--primary', item.kind === 'combo' ? 'Beide in den Warenkorb' : 'In den Warenkorb');
      add.type = 'button';
      var key = String(basket.size);
      basket.set(key, item.items.map(function (p) { return { id: Number(p.id), quantity: 1 }; }));
      add.dataset.ptwcCart = key;
      actions.appendChild(add);
      row.appendChild(actions);
      body.appendChild(row);
      card.appendChild(media);
      card.appendChild(body);
      return card;
    }
    function renderResults() {
      var token = ++renderToken;
      var q = request();
      basket.clear();
      summary.replaceChildren();
      results.replaceChildren();
      var labels = [
        q.mode === 'existing' ? 'Bestehender Ausschnitt' : 'Neuer Ausschnitt',
        q.width + ' × ' + q.height + ' mm',
        q.wall + (q.location === 'dach' ? ' mm Dachstärke' : ' mm Wandstärke'),
        LOCATION_LABELS[q.location] || 'Einbauort offen',
        q.rollo === 'yes' ? 'Mit Verdunkelung + Insektenschutz' : q.rollo === 'no' ? 'Nur Fenster' : 'Rollo optional'
      ];
      labels.forEach(function (text) { summary.appendChild(node('span', 'ptwc__summary-pill', text)); });
      if (q.structure === 'blocked') {
        addNotice(results, 'danger', 'Für den gewählten Einbauort wurden Streben, tragende Teile oder andere Hindernisse angegeben. Vor der Produktauswahl muss die konstruktive Eignung fachgerecht geklärt werden.');
        showEmpty('Einbaufläche bitte zuerst überprüfen lassen.', 'Eine Produktgröße allein ist keine Freigabe zum Sägen oder Verändern der Karosserie.');
        return;
      }
      if (q.structure === 'unknown' || q.location === 'sonstiges') {
        addNotice(results, 'warning', 'Achtung: Die konstruktive Eignung des Einbauortes ist noch nicht bestätigt. Die folgenden Produkte sind nur anhand der eingegebenen Maße und technischen Eigenschaften vorausgewählt.');
      }
      if (q.mode === 'new') {
        addNotice(results, 'soft', 'Größen-Vorauswahl: Für die angegebene maximale Öffnung wurden kleinere bzw. gleich große Ausschnittsmaße berücksichtigt. Ob der größere Außenrahmen und das Rollo in die Fläche passen, muss separat geprüft werden.');
      }
      if (q.location === 'dach') {
        addNotice(results, 'soft', 'Für die Dachfläche empfehlen wir keine Pantheratec-Seitenfenster. Dachfenster und Dachhauben werden getrennt geprüft; eine Produktgröße allein ist keine Einbaufreigabe.');
        var roof = sortResults(products.filter(function (item) { return roofMatch(item, q); }).map(function (item) {
          return { primary: item, items: [item], kind: 'roof', source: item.origin };
        }), q);
        roof.sort(function (a, b) { return (a.source === 'own' ? 0 : 1) - (b.source === 'own' ? 0 : 1); });
        if (roof.length) {
          results.appendChild(paragraph('Folgende Dachprodukte wurden im Theme-Editor anhand der Herstellerdaten geprüft und sind derzeit in Shopify verfügbar:', 'ptwc__results-intro'));
          results.appendChild(listGroup('Geprüfte Dachfenster nach deinen Eingaben', roof, true));
        } else {
          addNotice(results, 'warning', 'Noch kein technisch vollständig geprüfter, aktuell verfügbarer Dachartikel ist für diese Eingaben hinterlegt. Wir zeigen dir daher verfügbare Shop-Treffer zur Prüfung der Herstellermaße an.');
        }
        showRoofSearch(q, roof, token);
        return;
      }
      var own = sortResults(pickOwn(products, q), q);
      var other = sortResults(pickOther(products, q), q);
      if (own.length) {
        results.appendChild(paragraph('Passende, verfügbare Pantheratec-Produkte werden zuerst gezeigt. Deine bevorzugte Größe steht jeweils vorn.', 'ptwc__results-intro'));
        results.appendChild(listGroup('Pantheratec – passend nach Eingaben', own, true));
        if (other.length) {
          var alternatives = node('details', 'ptwc__alternatives');
          alternatives.appendChild(node('summary', '', 'Weitere geprüfte Markenfenster anzeigen (' + other.length + ')'));
          var content = node('div');
          content.appendChild(listGroup('Weitere verfügbare Markenfenster', other, false));
          alternatives.appendChild(content);
          results.appendChild(alternatives);
        }
      } else if (other.length) {
        addNotice(results, 'soft', 'Aktuell erfüllt kein verfügbarer Pantheratec-Artikel alle gewählten Kriterien. Hier sind technisch hinterlegte und verfügbare Markenalternativen.');
        results.appendChild(listGroup('Verfügbare Markenalternativen', other, true));
      } else {
        var reason = '';
        if (q.wall < 26 || q.wall > 35) reason = 'Deine Wandstärke liegt außerhalb des Pantheratec-Bereichs von 26–35 mm. ';
        if (q.opening === 'schiebe' || q.opening === 'fest') reason += 'Pantheratec bietet derzeit nur Ausstellfenster an. ';
        if (q.rollo === 'yes') reason += 'Für diese Auswahl muss ein verfügbares Rollo-Set oder ein verfügbares Fenster mit passendem verfügbarem Rollo vorhanden sein. ';
        if (q.mode === 'existing') reason += 'Für einen bestehenden Ausschnitt akzeptieren wir nur identische Nennmaße; Toleranzen werden nicht geschätzt. ';
        showEmpty('Aktuell keine sicher zuordenbare Produktempfehlung.', reason + 'Das bedeutet nicht, dass es generell kein Fenster für dein Fahrzeug gibt. Prüfe die Maße und sieh dir das gesamte Sortiment an.');
      }
      if (own.length || other.length) {
        var caveat = paragraph('Die Auswahl garantiert keine Montage-Eignung. Bitte vergleiche Außenrahmenmaße, Einbauschablone, Fahrzeugvorgaben und den fertigen Wandaufbau auf der Produktseite.', 'ptwc__results-intro');
        results.appendChild(caveat);
      }
    }
    function showEmpty(title, message) {
      var empty = node('div', 'ptwc__results-empty');
      empty.appendChild(node('h4', '', title));
      empty.appendChild(paragraph(message));
      var all = node('a', 'ptwc__button ptwc__button--outline', 'Alle Camperfenster ansehen →');
      all.href = config.fallbackUrl || '/collections/wohnmobil-fenster-und-innenrollos';
      empty.appendChild(all);
      results.appendChild(empty);
    }
    function reset() {
      ++renderToken;
      form.reset();
      updateMode();
      updateLocation();
      setStep(0);
    }
    next.addEventListener('click', function () {
      if (!validate(current)) return;
      if (current < 3) setStep(current + 1);
    });
    back.addEventListener('click', function () { if (current > 0) setStep(current - 1); });
    root.querySelector('[data-ptwc-reset]').addEventListener('click', reset);
    form.addEventListener('change', function (event) {
      clearError();
      if (event.target.name === 'mode') updateMode();
      if (event.target.name === 'location') updateLocation();
    });
    form.addEventListener('submit', function (event) { event.preventDefault(); if (validate(current) && current < 3) setStep(current + 1); });
    results.addEventListener('click', function (event) {
      var button = event.target.closest('[data-ptwc-cart]');
      if (!button || !results.contains(button) || button.disabled) return;
      var items = basket.get(button.dataset.ptwcCart);
      if (!items || !items.length) return;
      var old = button.textContent;
      button.disabled = true;
      button.textContent = 'Wird hinzugefügt …';
      var cartRoot = String(config.root || '/');
      if (!cartRoot.endsWith('/')) cartRoot += '/';
      fetch(cartRoot + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ items: items })
      }).then(function (response) {
        if (!response.ok) return response.json().catch(function () { return {}; }).then(function (body) {
          throw new Error(body.description || body.message || 'Das Produkt ist aktuell nicht verfügbar.');
        });
        window.location.assign(cartRoot + 'cart');
      }).catch(function (problem) {
        button.disabled = false;
        button.textContent = old;
        var existing = button.parentElement.parentElement.parentElement.querySelector('.ptwc__cart-error');
        if (existing) existing.remove();
        button.parentElement.parentElement.parentElement.appendChild(paragraph('Warenkorb konnte nicht aktualisiert werden: ' + problem.message, 'ptwc__cart-error'));
      });
    });
    updateMode();
    updateLocation();
    // Keep original page position on first load; do not automatically scroll.
    panels.forEach(function (panel, index) { panel.hidden = index !== 0; });
    navigation.hidden = false;
  }
  function scan(context) {
    if (context && context.matches && context.matches('[data-ptwc]')) init(context);
    if (context && context.querySelectorAll) context.querySelectorAll('[data-ptwc]').forEach(init);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { scan(document); }, { once: true });
  } else {
    scan(document);
  }
  document.addEventListener('shopify:section:load', function (event) { scan(event.target); });
})();
